import Constants from '../../constants/constants';

const roleClaimMap = {
  default: [],
  [Constants.ADMIN_ROLE_LEVEL]: [
    'user::dashboard::*',
    'user::player::*',
    'user::team::*',
    'user::player::archived::*',
    'user::admin-dashboard::*',
    'user::singleGame::*',
    'user::profile::*',
    'user::logOut::*',
    'user::resetPassword::*',
    'user::tournament::*',
    'user::communication::*',
    'user::masquerade::*',
    'user::lms::*',
    'user::cboard::*',
    'user::wellness::*',
    'user::therapist-wellness::*',
    'user::remote-therapy::*',
    'user::wellness-play::*',
  ],
  [Constants.ORGANIZATION_ADMIN_ROLE_LEVEL]: [
    'user::dashboard::*',
    'user::player::*',
    'user::team::*',
    'user::analytics::*',
    'user::player::archived::*',
    'user::singleGame::*',
    'user::profile::*',
    'user::logOut::*',
    'user::lms::*',
    'user::resetPassword::*',
    'user::cboard::*',
    'user::therapist-wellness::*',
    'user::remote-therapy::*',
    'user::wellness-play::*',
  ],
  [Constants.THERAPIST_ROLE_LEVEL]: [
    'user::dashboard::*',
    'user::player::*',
    'user::team::*',
    'user::player::archived::*',
    'user::singleGame::*',
    'user::profile::*',
    'user::logOut::*',
    'user::lms::*',
    'user::resetPassword::*',
    'user::cboard::*',
    'user::therapist-wellness::*',
    'user::remote-therapy::*',
    'user::wellness-play::*',
  ],
  [Constants.CNA_ROLE_LEVEL]: [
    'user::restorative-player-list::*',
    'user::logOut::*',
    'user::cna-wellness::*',
    'user::cna-single-game::*',
    'user::cna-cboard::*',
    'user::team::*',
    'user::wellness-play::*',
  ],
  [Constants.CARE_PARTNER_ROLE_LEVEL]: [
    'user::care-partner-dashboard::*',
    'user::care-partner-single-game::*',
    //'user::singleGame::*',
    'user::care-partner-wellness::*',
    'user::profile::*',
    'user::logOut::*',
    'user::lms::*',
    'user::resetPassword::*',
    'user::cboard::*',
    'user::wellness-play::*',
  ],
  [Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL]: [
    'user::logOut::*',
    'user::profile::*',
    'user::resetPassword::*',
    'user::business-group-analytics::*',
    'user::business-group-admin-dashboard::*',
    'user::cboard::*',
    'user::lms::*',
  ],
  [Constants.REGIONAL_ADMIN_ROLE_LEVEL]: [
    'user::logOut::*',
    'user::profile::*',
    'user::resetPassword::*',
    'user::business-group-analytics::*',
    'user::business-group-admin-dashboard::*',
    'user::cboard::*',
    'user::lms::*',
  ],
  [Constants.PLAYER_ROLE_LEVEL]: [
    'user::logOut::*',
    'user::profile::*',
    'player::dashboard::*',
    'player::singleGame::*',
    'player::conference::*',
    'user::resetPassword::*',
    'player::remote-therapy::*',
    'user::lms::*',
  ],
  forceResetPassword: ['user::resetPassword::*', 'user::logOut::*'],
};
const REVERT_MASQUERADE_CLAIM = 'user::masquerade::revert';
const getClaimsByRole = (roleLevel, isMasqueraded, passwordChange) => {
  let claims = [];
  if (passwordChange) {
    claims = roleClaimMap.forceResetPassword;
  } else if (!(roleLevel in roleClaimMap)) {
    claims = [...roleClaimMap.default];
  } else {
    claims = [...roleClaimMap[roleLevel]];
  }
  if (isMasqueraded) {
    claims.push(REVERT_MASQUERADE_CLAIM);
  }
  return claims;
};

export const filterByRole = (itemList, roleLevel, isMasqueraded) => {
  if (typeof roleLevel === 'undefined' || roleLevel === null) {
    return [];
  }

  const claims = getClaimsByRole(roleLevel, isMasqueraded);

  return itemList.filter((item) => claims.includes(item.claim));
};

export default getClaimsByRole;
